// Muster-Daten und Hilfsfunktion fuer die Live-Vorschau der Belegarten.
// Diese Struktur entspricht exakt den Daten, mit denen das Backend das echte
// EJS-Rechnungstemplate rendert (siehe node-js-jwt-auth/preview-server.js und
// app/utils/germanInvoice.js), damit die Vorschau dem echten Beleg entspricht.

// 1:1 uebernommen aus app/utils/germanInvoice.js (NaN-sicher).
export const formatCurrency = (amount, symbol) => {
  const num = parseFloat(amount);
  if (isNaN(num)) {
    return "0,00 " + (symbol || "€");
  }
  return num.toFixed(2).replace(".", ",") + " " + (symbol || "€");
};

// Muster-Datensatz passend zur Vorlage (entspricht previewInvoiceData im Backend).
export const invoicePreviewSample = {
  header: {
    company_name: "EDEL Investment GmbH",
    company_address_line1: "Marienburger Str. 2D",
    company_address_line2: "40789 Monheim am Rhein",
    company_address_line3: "Deutschland",
    company_tel: "+491712922222",
    company_email: "edelabcmail@gmail.com",
    company_logo: "",
  },
  order_number: "1",
  date: {
    billing_date: "04.02.2025",
    due_date: "18.02.2025",
    service_period: "04.02.2025-04.02.2026",
  },
  shipping: {
    name: "Prinus Personalmanagement GmbH",
    address: "Altenberger Gasse 178",
    city_zip_country: "Bornheim 53332, Deutschland",
    contact: "Jürgen Schmitz",
  },
  items: [
    { name: "TEST15", description: "GOOGLE Review myn.club", price: 4.0, quantity: 12, tax: 19 },
    { name: "Activation Fee", description: "One-time setup fee", price: 10.0, quantity: 1, tax: 19 },
  ],
  nettotal: 58.0,
  taxtotal: 11.02,
  total: 69.02,
  currency_symbol: "€",
  // Storno-Hinweis ist im echten Beleg optional; in der Vorschau standardmaessig leer.
  notes: "",
  footer: {
    payment_notice:
      "Vielen Dank für Ihren Einkauf. Wir bitten Sie den offenen Betrag bis zum 18.02.2025 auf das u.a. Konto zu überweisen.",
    bank_details:
      "EDEL Investment GmbH, Bank Name: Kreissparkasse Köln, SWIFT Code: COKSDE33XXX, IBAN: DE19370502990006015235",
    company_meta: "Handelsregister Nr.:, Amtsgericht:, GF:, St.-Nr.:, UST.-Id:",
  },
};
